import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  Lang: "en",
  ViewType: window.innerWidth,
  Rtl: false,
  Loader: null,
  Modal: null,
  Sidebar: false,
  Maintenance : false,
  BackTo : "",
};
const Reducer = createSlice({
  name: "Helper",
  initialState,
  reducers: {
    SetNewLang: (state, action) => {
      if (action.payload === "ar") {
        return {
          ...state,
          Lang: action.payload,
          Rtl: true,
        };
      }
      return {
        ...state,
        Lang: action.payload,
        Rtl: false,
      };
    },
    ToggleLoader: (state) => {
      return {
        ...state,
        Loader: !state.Loader,
      };
    },
    ToggleSidebar: (state) => {
      return {
        ...state,
        Sidebar: !state.Sidebar,
      };
    },
    OpenModal: (state, action) => {
      return {
        ...state,
        Modal: action.payload,
      };
    },
    CloseModal: () => {
      return {
        Modal: null,
      };
    },
    SetHelperData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export default Reducer.reducer;
export const {
  SetNewLang,
  ToggleLoader,
  ToggleSidebar,
  OpenModal,
  CloseModal,
  SetHelperData,
} = Reducer.actions;
